import {ChangeDetectorRef, Component} from '@angular/core';
import {ConfirmationService, MessageService} from 'primeng/api';
import {TranslateService} from '@ngx-translate/core';
import {CcBaseComponent} from "../../cc-base.component";

@Component({
  template: '',
  providers: [
    MessageService,
    ConfirmationService,
    TranslateService,
  ],
})
export class CcSubDetailBaseComponent extends CcBaseComponent {

  constructor(protected cdref: ChangeDetectorRef,
              protected messageService: MessageService,
              protected translateService: TranslateService) {
    super(cdref, messageService, translateService);
  }

  public reloadFieldValueMap(): void {
    this.markForCheck();
  }

}
